<template>
  <div class="editorContent">
    <Editor v-model="content.bodyHtml" :init="initData" api-key="aqkrrafmxu16m6k7274616asxdvpjgdexwut7vfph5bt8rdz" :key="richTextKey" />
    <div class="htmlLength">{{`${htmlLengthStr} word`}}</div>
  </div>

</template>

<script>
import tinymce from 'tinymce/tinymce' // 引入我们下载的tinymce包
import '../../../../../public/static/tinymce/themes/modern/theme' // 引入theme文件，必须要引入的
import Editor from '@tinymce/tinymce-vue' // 必须要引官方给我们的配置vue包
// 下方import引入都是文本编辑器中的配置项，这个根据个人需求去引入
// import '../../../public'
import '../../../../../public/static/tinymce/plugins/image'
import '../../../../../public/static/tinymce/plugins/link'
import '../../../../../public/static/tinymce/plugins/code'
import '../../../../../public/static/tinymce/plugins/table'
import '../../../../../public/static/tinymce/plugins/lists'
import '../../../../../public/static/tinymce/plugins/contextmenu'
import '../../../../../public/static/tinymce/plugins/wordcount'
import '../../../../../public/static/tinymce/plugins/colorpicker'
import '../../../../../public/static/tinymce/plugins/textcolor'
import '../../../../../public/static/tinymce/plugins/paste'

import API from '@/api'
export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Editor
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.richTextLanguageInit(newValue)
    }
  },
  created() {
    this.richTextLanguageInit(this.$store.state.language)
  },
  computed: {
    // 返回去除标签的长度
    htmlLengthStr() {
      let str = this.content.bodyHtml ? this.content.bodyHtml.trim() : ''
      let filterStr = str.replace(/<[^>]+>|&[^>]+;/g, '')
      return filterStr.length
    }
  },
  data() {
    return {
      tinymce,
      isImageChange: false,
      isImageChangeUrl: '',
      initData: {
        forced_root_block: '',
        language_url: '/static/tinymce/langs/fr_FR.js', // 配置中文的路径
        language: 'fr_FR',
        skin_url: '/static/tinymce/skins/lightgray', // 配置项的路径
        height: 400,
        plugins: 'paste link lists image code table colorpicker textcolor contextmenu',
        toolbar:
          'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        selector: 'textarea',
        wordcount_countregex: /[\w\u2019\x27\-\u00C0-\u1FFF]+/g,
        // 设置为“true”即允许粘贴图像，而将其设置为“false”则不允许粘贴图像。
        paste_data_images: true,
        // 图片读取前缀路径
        images_upload_base_path: process.env.VUE_APP_DOMAIN,
        // 图片本地上传方法  点击上传后执行的事件
        images_upload_handler: (blobInfo, success, failure) => {
          this.handleImgUpload(blobInfo, success, failure)
        }
      },
      richTextKey: 0
    }
  },
  methods: {
    async handleImgUpload(blobInfo, success, failure) {
      try {
        // 先获取凭证
        let signValue = await API.orderSignValue({ directory: 'describe/' })
        const uploadParams = new FormData()
        uploadParams.append('directory', 'describe/')
        uploadParams.append('signValue', signValue.data)
        uploadParams.append('fileList', blobInfo.blob())
        let urls = await API.orderUploadFile(uploadParams)
        let url = urls.data
        // url替换成速度更快的源
        if (urls.data.includes('hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com')) {
          url = urls.data.replace(/img.kakaclo.com/, 'hbo-shenzhen.oss-accelerate.aliyuncs.com')
        } else if (urls.data.includes('img-kakaclo-url.oss-cn-shenzhen.aliyuncs.com')) {
          url = urls.data.replace(/img-kakaclo-url.oss-cn-shenzhen.aliyuncs.com/, 'img-kakaclo-url.oss-accelerate.aliyuncs.com')
        }
        success(url)
      } catch (error) {
        failure('')
      }
    },
    // 富文本根据语种初始化
    richTextLanguageInit(language) {
      const langsObj = {
        de: 'de',
        es: 'es_419',
        fr: 'fr_FR',
        'ru-RU': 'ru',
        'zh-CN': 'zh_CN',
        en: 'en'
      }
      if (langsObj[language] !== 'en') {
        this.initData.language = langsObj[language]
        this.initData.language_url = `/static/tinymce/langs/${langsObj[language]}.js`
      } else {
        this.initData.language = 'en'
        this.initData.language_url = undefined
      }
      this.richTextKey = new Date().getTime()
    }
  }
}
</script>

<style lang="scss" scoped>
.editorContent {
  position: relative;
}
.htmlLength {
  position: absolute;
  right: 50px;
  bottom: 6px;
}
</style>
